module.exports = __webpack_public_path__ + "img/no_planned_goals.66c45a4e.svg";